import { IpaType } from "../../phonemes/ipa";

interface IpaListProps {
  /** list of space-delimited ipa to display (a comma is turned into an extra space) */
  readonly items: IpaType;
  /** items in this list will show as bold (string is space-delimited) */
  readonly bolded?: IpaType | Set<IpaType>;
  /** called when a symbol is clicked on */
  readonly clicked?: (ipa: IpaType) => void;
  readonly rightClicked?: (ipa: IpaType) => void;
  readonly hovered?: (ipa: IpaType) => void;
}

/** show a list of IPA symbols, optionally bolding & responding to clicks */
export function IpaList(props: IpaListProps) {
  const items = props.items.split(' ').map(item => item === ',' ? ' ' : item);
  const bolded = new CheckBold(props.bolded);

  function rightClick(e: RightClickEvent, ipa: IpaType) {
    if (props.rightClicked) {
      props.rightClicked(ipa);
      e.preventDefault(); // stop the context menu from appearing
    }
  }
  function over(ipa: IpaType) {
    if (props.hovered && ipa) {
      props.hovered(ipa);
    }
  }

  return (<>
    {items.map((item, i) =>
      <span key={i}
        className={props.clicked || props.rightClicked ? 'pointer' : 'nopointer'}
        onClick={() => props.clicked ? props.clicked(item) : undefined}
        onMouseOver={() => over(item)}
        onContextMenu={(e) => rightClick(e, item)}
      >
        {bolded.has(item) ? <b>{item}</b> : item}
        &nbsp;
      </span>
    )}
  </>);
}

interface RightClickEvent {
  preventDefault(): void;
}

class CheckBold {
  private set: Set<IpaType>;

  constructor(list: IpaType | Set<IpaType> | undefined) {
    if (list === undefined) {
      this.set = new Set<IpaType>();
    } else if (typeof list === 'string') {
      this.set = new Set<IpaType>();
      const split = list.split(' ');
      split.forEach(s => this.set.add(s));
    } else {
      this.set = list;
    }
  }

  has(item: IpaType): boolean {
    return this.set.has(item);
  }
}
